import { render, staticRenderFns } from "./Theme1SectionContact.vue?vue&type=template&id=2505ecd4&scoped=true&"
import script from "./Theme1SectionContact.vue?vue&type=script&lang=js&"
export * from "./Theme1SectionContact.vue?vue&type=script&lang=js&"
import style0 from "./Theme1SectionContact.vue?vue&type=style&index=0&id=2505ecd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505ecd4",
  null
  
)

export default component.exports